import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import "./i18n"; // initialises i18next before App mounts
import App from "./App";

// Sentry: leerer DSN = init no-op, App startet normal weiter.
const sentryDsn = (process.env.REACT_APP_SENTRY_DSN || "").trim();
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_ENV || "development",
    release: process.env.REACT_APP_GIT_SHA || "dev",
    sendDefaultPii: false,
    // Default-Integrations EXPLIZIT eingeschränkt: keine browserTracing
    // (wrappt React-19 flushSync mit performance.measure() -> DataCloneError
    // + "Should not already be working" Scheduler-Error -- bekannte
    // @sentry/react 10 + React 19 Inkompatibilität).
    // Keine Session-Replay -- rrweb-Plugin macht zusätzlichen DOM-Trace,
    // den wir aktuell nicht brauchen und der Performance kostet.
    // Wenn Tracing/Replay später gewünscht: gezielt re-enablen sobald
    // Sentry React-19-kompatibel ist.
    defaultIntegrations: false,
    integrations: [
      Sentry.breadcrumbsIntegration(),
      Sentry.dedupeIntegration(),
      Sentry.functionToStringIntegration(),
      Sentry.globalHandlersIntegration(),
      Sentry.httpContextIntegration(),
      Sentry.inboundFiltersIntegration(),
      Sentry.linkedErrorsIntegration(),
    ],
    // React-19-Dev-Noise filtern. Diese Fehler werden von React's eigener
    // Profiling-Instrumentation ausgeloest (sichtbar bei aktiver React-
    // DevTools-Browser-Extension) und crashen die App NICHT -- sie sind
    // pure Dev-Telemetrie. In Production-Builds tauchen sie nicht auf.
    ignoreErrors: [
      "Should not already be working",
      /Failed to execute 'measure' on 'Performance'/,
      // ResizeObserver-Loop ist auch ein Browser-Quirk, kein Bug
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
    ],
  });
  // In Dev/Staging: Sentry auf window verfügbar machen für Debug-Calls
  // wie window.Sentry.captureException(new Error("test")). In Production
  // weglassen — kein Grund, Internals zu exposen.
  if ((process.env.REACT_APP_ENV || "development") !== "production") {
    window.Sentry = Sentry;
  }
}

const SentryFallback = ({ error, resetError }) => (
  <div style={{ padding: "2rem", fontFamily: "system-ui", textAlign: "center" }}>
    <h2>Etwas ist schiefgelaufen.</h2>
    <p style={{ color: "#666" }}>{error?.message || "Unbekannter Fehler"}</p>
    <button
      onClick={resetError}
      style={{
        marginTop: "1rem",
        padding: "0.5rem 1rem",
        background: "#1e3a8a",
        color: "white",
        border: "none",
        borderRadius: "0.25rem",
        cursor: "pointer",
      }}
    >
      Neu laden
    </button>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
